import { render, staticRenderFns } from "./complaint_cont.vue?vue&type=template&id=dda61bc6&scoped=true"
import script from "./complaint_cont.vue?vue&type=script&lang=js"
export * from "./complaint_cont.vue?vue&type=script&lang=js"
import style0 from "./complaint_cont.vue?vue&type=style&index=0&id=dda61bc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda61bc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dda61bc6')) {
      api.createRecord('dda61bc6', component.options)
    } else {
      api.reload('dda61bc6', component.options)
    }
    module.hot.accept("./complaint_cont.vue?vue&type=template&id=dda61bc6&scoped=true", function () {
      api.rerender('dda61bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/complaintreporting/online/components/complaint_cont.vue"
export default component.exports